import { RouterProvider } from "react-router-dom";
import Log from "@webcore/services/log/log.ts";
import { appConfig } from "@webcore/config/appConfig.ts";
import contentBrowserRouter from "@/routes/ContentSiteRoutes.tsx";

Log.debug("App.tsx start", { x: appConfig.contentBaseUrl });

function App() {
  return (
    <RouterProvider router={contentBrowserRouter} />
  );
}

export default App;
